import modalAccessibility from "core-ui/client/src/app/ModalAccessibility";

var BeneficiarySaveChangesController = function ($scope, $injector, $modalInstance, LegacyService) {
    var vm = this;
    var $state = $injector.get("$state");
    var $timeout = $injector.get("$timeout");
    var beneficiaryService = $injector.get("beneficiaryService");
    var $translate = $injector.get("$translate");
    var menuService = $injector.get("MenuService");

    modalAccessibility.onOpenModal(".modal-content");

    function callAtTimeout() {
        menuService.setActiveMenuItem();
    }

    vm.onDoNotSaveClick = function () {
        // reset the flags for the modal
        beneficiaryService.resetSaveChangesModal();

        $modalInstance.close();
        var $window = $injector.get("$window");
        var originState = beneficiaryService.getToState();

        if (originState.name === "profile") {
            $window.location.href = beneficiaryService.getProfileLink();
        } else {
            LegacyService.setFrameSrcUrl(null);
            $state.go(originState, beneficiaryService.getToStateParams());
        }

        // this sets active menu item
        $timeout(callAtTimeout, 3000, { reload: true });
    };

    vm.onStaySaveClick = function () {
        beneficiaryService.setDialogLoading(false);
        $modalInstance.dismiss("cancel");
    };
};

BeneficiarySaveChangesController.$inject = [
    "$scope",
    "$injector",
    "$modalInstance",
    "LegacyService"
];

export default BeneficiarySaveChangesController;
